/**
 * File: es_ES.js
 * Project: Noname-Base-Frontend
 * File Created: Wednesday, 11th June 2025 3:44:12 pm
 * Author: Jorge Sierra Blázquez (jorge.sierra@aerin.es)
 * Version: 2.0.0
 * -----
 * Last Modified: Monday, 4th August 2025 1:29:31 pm
 * Modified By: Alexandru Ionut Dascalu
 * -----
 * Copyright (c) 2023 - 2025 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 */

/* Gogo Textos de Lenguaje

Tabla de Contenido

01.General
02.Inicio de sesión de usuario, cierre de sesión, registro
03.Menú
04.Tableros
05.Esquemas
06.Aplicaciones
  06.01.Chatea
  06.02.Encuesta
  06.03.Notas
07.IU
  07.01.Alertas
  07.02.Badges
  07.03.Botones
  07.04.Tarjetas
  07.05.Carrusel
  07.06.Gráficos
  07.07.Colapso
  07.08.Desplegables
  07.09.Editores
  07.10.Formularios
  07.11.Componentes
  07.12.Iconos
  07.13.Grupos de Entrada
  07.14.Jumbotron
  07.15.Modal
  07.16.Navegación
  07.17.Tooltips y Popovers
  07.18.Ordenable
  07.19.Maps
  07.20.Tables
  07.21.Tables
  07.22.Errors
*/

module.exports = {
  /* 01.General */
  'general.copyright': 'Noname © 2022 Todos los derechos reservados.',
  'general.project-name': 'NONAME',

  'unauthorized.title': 'Intento de acceso no autorizado',
  'unauthorized.detail':
    'No está autorizado para ver la página a la que intenta acceder.',

  /* 02.Inicio de sesión de usuario, cierre de sesión, registro */
  'user.login-title': 'Iniciar sesión',
  'user.register': 'Registro',
  'user.forgot-password': 'Se te olvidó tu contraseña',
  'user.email': 'Email',
  'user.password': 'Contraseña',
  'user.forgot-password-question': '¿Contraseña olvidada?',
  'user.fullname': 'Nombre completo',
  'user.login-button': 'INICIAR SESIÓN',
  'user.login-sso': 'Iniciar sesión con SSO',
  'user.sso-redirecting': 'Redirigiendo...',
  'user.sso-authenticating': 'Autenticando...',
  'user.sso-error':
    'No se ha podido iniciar sesión con SSO. Comprueba que tu usuario tiene acceso a la aplicación o inicia sesión con usuario y contraseña.',
  'user.sso-error-user-not-found':
    'Tu cuenta no está dada de alta en la aplicación. Contacta con el administrador para que te dé acceso.',
  'user.sso-error-inactive':
    'Tu usuario está desactivado. Contacta con el administrador.',
  'user.register-button': 'REGISTRO',
  'user.reset-password-button': 'REINICIAR',
  'user.buy': 'COMPRAR',
  'user.username': 'Nombre de Usuario',
  'user.new-password-again': 'Nueva contraseña de nuevo',
  'user.new-password': 'Nueva Contraseña ',
  'user.reset-password': 'Restablecer la contraseña',
  'user.warning-message': 'Por favor use sus credenciales para acceder.',
  'user.error.internal-server':
    'Error interno del servidor. Por favor, inténtelo de nuevo más tarde.',
  'user.error.invalid-credentials':
    'Credenciales inválidas. Por favor, compruebe su nombre de usuario y contraseña.',
  'user.error.generic':
    'Se ha producido un error. Por favor, inténtelo de nuevo.',
  'user.error.no-response':
    'No hay respuesta del servidor. Por favor, compruebe su conexión o inténtelo de nuevo más tarde.',
  'user.error.config-request': 'Error al configurar la solicitud.',
  'user.error.login': 'Error de inicio de sesión.',
  'user.error.expired-token': 'Token de sesión expirado.',

  /* 03.Menú */
  'menu.home': 'Inicio',
  'menu.app': 'Inicio',
  'menu.dashboards': 'Tableros',
  'menu.default': 'Defecto',
  'menu.analytics': 'Analítica',
  'menu.ecommerce': 'Comercio electrónico',
  'menu.content': 'Contenido',
  'menu.pages': 'Páginas',
  'menu.administration': 'Administración',
  'menu.audits': 'Auditoría',
  'menu.accounts': 'Usuarios',
  'menu.data-list': 'Lista Datos',
  'menu.thumb-list': 'Lista Pulgares',
  'menu.image-list': 'Lista Imagen',
  'menu.details': 'Detalles',
  'menu.search': 'Búsqueda',
  'menu.login': 'Iniciar sesión',
  'menu.register': 'Registro',
  'menu.forgot-password': 'Olvidé mi contraseña',
  'menu.reset-password': 'Reset Password',
  'menu.error': 'Error',
  'menu.applications': 'Aplicaciones',
  'menu.todo': 'Notas',
  'menu.survey': 'Encuesta',
  'menu.chat': 'Chatea',
  'menu.ui': 'IU',
  'menu.alerts': 'Alertas',
  'menu.badges': 'Badges',
  'menu.buttons': 'Botones',
  'menu.cards': 'Tarjetas',
  'menu.carousel': 'Carrusel',
  'menu.charts': 'Gráficos',
  'menu.collapse': 'Colapso',
  'menu.dropdowns': 'Menús Desplegables',
  'menu.editors': 'Editores',
  'menu.form-layouts': 'Diseños de Formulario',
  'menu.form-components': 'Componentes de Formulario',
  'menu.form-validations': 'Validaciones de Formulario',
  'menu.form-wizard': 'Asistente de Formulario',
  'menu.icons': 'Iconos',
  'menu.input-groups': 'Grupos de Entrada',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navegación',
  'menu.popover-tooltip': 'Tooltips y Popovers',
  'menu.sortable': 'Ordenable',
  'menu.tables': 'Tablas',
  'menu.menu': 'Menú',
  'menu.subhidden': 'Sub Oculto',
  'menu.hidden': 'Oculto',
  'menu.visible': 'Visible',
  'menu.maps': 'Mapas',
  'menu.landingpage': 'Página de Destino',
  'menu.multipage-home': 'Múltiple Página',
  'menu.singlepage-home': 'Una Página',
  'menu.about': 'Acerca de',
  'menu.auth-login': 'Autenticación',
  'menu.auth-register': 'Registro',
  'menu.blog': 'Blog',
  'menu.blog-list': 'Blog List',
  'menu.blog-detail': 'Detalle del Blog',
  'menu.careers': 'Carrera',
  'menu.confirmation': 'Confirmación',
  'menu.contact': 'Contacto',
  'menu.docs': 'Docs',
  'menu.features': 'Caracteristicas',
  'menu.prices': 'Precios',
  'menu.videos': 'Videos',
  'menu.mailing': 'Correo',
  'menu.invoice': 'Factura',
  'menu.blank-page': 'Blank Page',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',
  'menu.faq': 'Pmf',
  'menu.knowledge-base': 'Base de Conocimientos',
  'menu.authorization': 'Authorization',
  'menu.profile': 'Profile',
  'menu.product': 'Producto',
  'menu.miscellaneous': 'Diversa',
  'menu.portfolio': 'Portafolio',
  'menu.social': 'Social',
  'menu.details-alt': 'Details Alt',
  'menu.forms': 'Formulario',
  'menu.components': 'Componentes',
  'menu.layouts': 'Diseños',
  'menu.validations': 'Validaciones',
  'menu.wizard': 'Mago',

  /* Administration.accounts */
  'administration.accounts.create': 'Crear',
  'administration.accounts.cancel': 'Cancelar',
  'administration.accounts.tittle.create': 'Crear nuevo usuario',
  'administration.accounts.username': 'Usuario',
  'administration.accounts.email': 'Email',
  'administration.accounts.name': 'Nombre',
  'administration.accounts.lastname': 'Apellido',
  'administration.accounts.password': 'Contraseña',
  'administration.accounts.confirmpassword': 'Confirma contraseña',
  'administration.accounts.staff': 'Staff',
  'administration.accounts.administrator': 'Administrador',
  'administration.accounts.edit': 'Editar',
  'administration.accounts.delete': 'Eliminar',

  /* Administration.audits */
  'administration.audits.criticality': 'Criticidad',
  'administration.audits.date': 'Fecha',
  'administration.audits.app': 'Aplicación',
  'administration.audits.application': 'Nombre de la aplicación',
  'administration.audits.message': 'Mensaje',

  /* 04.Tableros */
  'dashboards.pending-orders': 'Pedidos Pendientes',
  'dashboards.completed-orders': 'Pedidos Completados',
  'dashboards.refund-requests': 'Petición de Reembolso',
  'dashboards.new-comments': 'Nuevos Comentarios',
  'dashboards.sales': 'Ventas',
  'dashboards.orders': 'Pedidos',
  'dashboards.refunds': 'Reembolso',
  'dashboards.recent-orders': 'Pedidos Recientas',
  'dashboards.product-categories': 'Categorías de Producto',
  'dashboards.cakes': 'Tortas',
  'dashboards.tickets': 'Entradas',
  'dashboards.calendar': 'Calendario',
  'dashboards.best-sellers': 'Mejores Vendidos',
  'dashboards.website-visits': 'Visitas al sitio web',
  'dashboards.unique-visitors': 'Visitantes únicos',
  'dashboards.this-week': 'Esta Semana',
  'dashboards.last-week': 'La Semana Pasada',
  'dashboards.this-month': 'Este Mes',
  'dashboards.conversion-rates': 'Medidas de Conversión',
  'dashboards.per-session': 'Por Sección',
  'dashboards.profile-status': 'Estado del Perfil',
  'dashboards.payment-status': 'Estado del Pago',
  'dashboards.work-progress': 'Trabajo en Progreso',
  'dashboards.tasks-completed': 'Tareas Completadas',
  'dashboards.payments-done': 'Pagos Realizados',
  'dashboards.order-stock': 'Pedidos - Valores',
  'dashboards.categories': 'Categorías',
  'dashboards.quick-post': 'Publicación Rápida',
  'dashboards.title': 'Título',
  'dashboards.content': 'Contenido',
  'dashboards.category': 'Categoría',
  'dashboards.save-and-publish': 'Guardar y Publicar',
  'dashboards.top-viewed-posts': 'Publicaciones Más Vistas',
  'dashboards.posts': 'Puestos',
  'dashboards.pending-for-publish': 'Pendiente de Publicación',
  'dashboards.users': 'Usuarios',
  'dashboards.on-approval-process': 'En Proceso de Aprobación',
  'dashboards.alerts': 'Alertas',
  'dashboards.waiting-for-notice': 'Esperando Aviso',
  'dashboards.files': 'Archivos',
  'dashboards.pending-for-print': 'Pendiente para imprimir',
  'dashboards.logs': 'Troncos',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'LA MAGIA ESTA EN LOS DETALLES',
  'dashboards.yes-it-is-indeed': '¡Si es verdad!',
  'dashboards.advanced-search': 'Búsqueda Avanzada',
  'dashboards.toppings': 'Coberturas',
  'dashboards.type': 'Categoría',
  'dashboards.keyword': 'Palabra Clave',
  'dashboards.search': 'Búsqueda',
  'dashboards.top-rated-items': 'Artículos Mejores Valorados',

  /* 05.Esquemas */
  'pages.add-new': 'AGREGAR NUEVO',
  'pages.add-new-modal-title': 'Agregar ítem nuevo',
  'pages.display-options': 'Opciones de Pantalla',
  'pages.orderby': 'Ordenar por : ',
  'pages.total': 'Total: ',
  'pages.viewing': 'Viewing : ',
  'pages.product-name': 'Nombre del Producto',
  'pages.category': 'Categoría',
  'pages.description': 'Descripción',
  'pages.status': 'Estado',
  'pages.cancel': 'Cancelar',
  'pages.submit': 'Enviar',
  'pages.delete': 'Borrar',
  'pages.another-action': 'Otra accion',
  'pages.actions': 'ACCIONES',
  'pages.header': 'Encabezado',
  'pages.details': 'DETALLES',
  'pages.orders': 'PEDIDOS',
  'pages.rating': 'Clasificación',
  'pages.price': 'Precio',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Es Vegano',
  'pages.order-status': 'Estado del Pedido',
  'pages.bake-progress': 'Progreso de Hornear',
  'pages.popularity': 'Popularidad',
  'pages.comments': 'Comentarios',
  'pages.error-title': 'Vaya, parece que ha ocurrido un error!',
  'pages.error-code': 'Código de error',
  'pages.go-back-home': 'REGRESAR A INICIO',
  'pages.mailing-info':
    'Las plantillas de correo utilizan el diseño en línea y el diseño de la tabla para mostrarse bien en varios proveedores de servicios. Para proporcionar una mejor usabilidad, lo incluimos como html regular con dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'La plantilla de factura tiene una versión de estilo en línea para uso fuera del proyecto, así como la versión React.',
  'pages.react-version': 'React Versión',
  'pages.inline-version': 'Estilo en Linea Html Versión',
  'pages.like': 'Me gusta',
  'pages.likes': 'Me gusta',
  'pages.details-title': 'Detalles',
  'pages.comments-title': 'Comentarios',
  'pages.questions-title': 'Preguntas',
  'pages.similar-projects': 'Proyectos Similares',
  'pages.send': 'Enviar',
  'pages.addComment': 'Añadir un comentario',
  'pages.location': 'Ubicación',
  'pages.responsibilities': 'Responsabilidades',
  'pages.photos': 'Fotos',
  'pages.who-to-follow': 'A quién seguir',
  'pages.follow': 'SEGUIR',
  'pages.followers': 'SEGUIDORES',
  'pages.recent-posts': 'Mensajes Recientes',
  'pages.profile': 'PERFIL',
  'pages.friends': 'AMIGOS',
  'pages.images': 'IMAGENES',
  'pages.purchase': 'COMPRA',
  'pages.price.developer': 'REVELADOR',
  'pages.price.team': 'EQUIPO',
  'pages.price.enterprise': 'EMPRESA',
  'pages.price.twofactorauthentication': 'Autenticación de dos factores',
  'pages.price.teampermissions': 'Permisos del equipo',
  'pages.price.245Support': '24/5 Soporte',
  'pages.price.247Support': '24/7 Soporte',
  'pages.price.useractionsauditlog': 'Registro de acciones del usuario',
  'pages.prices.featurecomparison': 'Comparación de Características',
  'pages.prices.pricecomparison': 'Comparación de Precios',

  /* 06.Aplicaciones */

  /* 06.01.Chatea */
  'chat.messages': 'Mensajes',
  'chat.contacts': 'Contactos',
  'chat.saysomething': 'Di algo..',

  /* 06.02.Encuesta */
  'survey.delete': 'Borrar',
  'survey.edit': 'Edit',
  'survey.add-new': 'AGREGAR NUEVO',
  'survey.add-new-title': 'Add New Encuesta',
  'survey.title': 'Título',
  'survey.category': 'Categoría',
  'survey.label': 'Etiqueta',
  'survey.status': 'Estado',
  'survey.cancel': 'Cancelar',
  'survey.submit': 'Enviar',
  'survey.another-action': 'Otra accion',
  'survey.display-options': 'Opciones de Pantalla',
  'survey.orderby': 'Ordenar por : ',
  'survey.all-surveys': 'Todas las Encuestas',
  'survey.completed-surveys': 'Encuestas Completadas',
  'survey.categories': 'Categorías',
  'survey.active-surveys': 'Encuestas Activas',
  'survey.labels': 'Etiquetas',

  /* 06.03.Notas */
  'todo.add-new': 'AGREGAR NUEVO',
  'todo.add-new-title': 'Añadir Nuevo',
  'todo.title': 'Título',
  'todo.detail': 'Detalle',
  'todo.category': 'Categoría',
  'todo.label': 'Etiqueta',
  'todo.status': 'Estado',
  'todo.cancel': 'Cancelar',
  'todo.submit': 'Enviar',
  'todo.action': 'Accion',
  'todo.another-action': 'Otra accion',
  'todo.display-options': 'Opciones de Pantalla',
  'todo.orderby': 'Ordenar por : ',
  'todo.all-tasks': 'Todas las Tareas',
  'todo.pending-tasks': 'Tareas Pendientes',
  'todo.completed-tasks': 'Tareas Completadas',
  'todo.categories': 'Categorías',
  'todo.labels': 'Etiquetas',

  /* 07.IU */

  /* 07.01.Alertas */
  'alert.rounded': 'Alerta Redondeado',
  'alert.react-notifications': 'React Notificaciones',
  'alert.outline': 'Contorno',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Lleno',
  'alert.primary-text': '¡Esto es un primary alert—check fuera!',
  'alert.secondary-text': '¡Esto es un secondary alert—check fuera!',
  'alert.success-text': '¡Esto es un success alert—check fuera!',
  'alert.danger-text': '¡Esto es un danger alert—check fuera!',
  'alert.warning-text': '¡Esto es un warning alert—check fuera!',
  'alert.info-text': '¡Esto es un info alert—check fuera!',
  'alert.light-text': '¡Esto es un light alert—check fuera!',
  'alert.dark-text': '¡Esto es un dark alert—check fuera!',
  'alert.default': 'Alerta por Defecto',
  'alert.dismissing': 'Despido de Alerta',
  'alert.dismissing-text':
    '¡Santo guacamole! Debes revisar algunos de esos campos a continuación.',
  'alert.dismissing-without-animate-text':
    '¡Estoy alerta y me pueden despedir sin animarme!',

  /* 07.02.Badges */
  'badge.sizes': 'Tamaños',
  'badge.colors': 'Colores',
  'badge.outline': 'Contorno',
  'badge.links': 'Enlaces',
  'badge.counter-badges': 'Mostrador Badges',
  'badge.bootstrap-default': 'Bootstrap Defecto',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Botones */
  'button.default': 'Bootstrap Defecto',
  'button.colors': 'Colores',
  'button.rounded': 'Botones Redondeado',
  'button.outline': 'Contorno',
  'button.states': 'Estados',
  'button.sizes': 'Tamaños',
  'button.button-groups': 'Grupos de Botones',
  'button.large-button': 'Botón Grande',
  'button.small-button': 'Botón Pequeño',
  'button.extra-small-button': 'Botón Extra Pequeño',
  'button.block-button': 'Botón de Bloqueo',
  'button.active': 'Activo',
  'button.disabled': 'Discapacitado',
  'button.basic': 'Básico',
  'button.toolbar': 'Barra de Herramientas',
  'button.nesting': 'Anidando',
  'button.vertical-variation': 'Variación Vertical',
  'button.checkbox-radio-button': 'Checkbox  y Radio Buttons',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'Este botón muestra una rueda giratoria durante 2 segundos y un icono de error durante 3 segundos antes de cambiar al estado normal. Estos estados se pueden activar agregando y eliminando clases.',
  'button.click-here': 'Haga clic aquí',
  'button.states-text-alternate':
    'Este botón muestra una rueda giratoria durante 2 segundos y un icono de error durante 3 segundos antes de cambiar al estado normal. Estos estados se pueden activar agregando y eliminando clases.',
  'button.primary-link': 'Primary Enlace',
  'button.link': 'Enlace',
  'button.primary-button': 'Primary Botón',
  'button.button': 'Botón',
  'button.left': 'Izquierda',
  'button.middle': 'Centro',
  'button.right': 'Derecha',
  'button.dropdown': 'Desplegable',
  'button.dropdown-link': 'Enlace Desplegable',

  /* 07.04.Tarjetas */
  'cards.icon-card': 'Tarjeta de Icono',
  'cards.image-card': 'Tarjeta de Imagen',
  'cards.image-overlay-card': 'Tarjeta de Superposición de Imágenes',
  'cards.image-card-list': 'Lista de Tarjetas de Imagen',
  'cards.tab-card': 'Tarjeta de Tab',
  'cards.user-card': 'Tarjeta de Usuario',

  /* 07.05.Carrusel */
  'carousel.basic': 'Carrusel Básico',
  'carousel.single': 'Carrusel Sólo',
  'carousel.without-controls': 'Carrusel sin Control',

  /* 07.06.Gráficos */
  'charts.line': 'Gráfico de Linea',
  'charts.polar': 'Gráfico de Polar',
  'charts.area': 'Gráfico de Área',
  'charts.scatter': 'Gráfico de Dispersión',
  'charts.bar': 'Gráfico de Barras',
  'charts.radar': 'Gráfico de Radar',
  'charts.pie': 'Gráfico de Circular',
  'charts.doughnut': 'Gráfico de Rosquilla',
  'charts.shadow': 'Sombra',
  'charts.no-shadow': 'Sin Sombra',

  /* 07.07.Colapso */
  'collapse.basic': 'Básico',
  'collapse.toggle': 'Palanca',
  'collapse.accordion': 'Acordeón',
  'collapse.controlled': 'Revisado',
  'collapse.uncontrolled': 'Sin Control',

  /* 07.08.Desplegables */
  'dropdowns.basic': 'Básico',
  'dropdowns.controlled': 'Revisado',
  'dropdowns.uncontrolled': 'Sin Control',
  'dropdowns.dropdown': 'Desplegable',
  'dropdowns.header': 'Encabezado',
  'dropdowns.action': 'Accion',
  'dropdowns.another-action': 'Otra accion',
  'dropdowns.right': 'Derecha',
  'dropdowns.left': 'Izquierda',
  'dropdowns.drop-directions': 'Direcciones de drop',
  'dropdowns.dropright': 'Drop Derecha',
  'dropdowns.dropleft': 'Drop Izquierda',
  'dropdowns.small-button': 'Botón Pequeño',
  'dropdowns.large-button': 'Botón Grande',
  'dropdowns.sizing': 'Dimensionamiento',
  'dropdowns.split-button': 'Botones Desplegables',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editores */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Estándar',
  'editors.quill-bubble': 'Quill Burbuja',

  /* 07.10.Formularios */
  'forms.basic': 'Básico',
  'forms.email': 'Email',
  'forms.email-muted': 'Nunca compartiremos tu email con nadie más.',
  'forms.password': 'Contraseña',
  'forms.password-confirm': 'Confirmar Contraseña',
  'forms.submit': 'Enviar',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'Primero radio',
  'forms.second-radio': 'Segundo radio',
  'forms.third-radio-disabled': 'Tercera radio deshabilitada',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Registrarse',
  'forms.top-labels-over-line': 'Etiquetas Superiores Sobre la Línea',
  'forms.tags': 'Etiquetas',
  'forms.date': 'Fecha',
  'forms.state': 'Estado',
  'forms.top-labels-in-input': 'Etiquetas Superiores Sobre la Entrada',
  'forms.email-u': 'EMAIL',
  'forms.password-u': 'CONTRASEÑA',
  'forms.tags-u': 'ETIQUETAS',
  'forms.date-u': 'FECHA',
  'forms.state-u': 'ESTADO',
  'forms.grid': 'Cuadrícula de Formulario',
  'forms.address': 'Dirección',
  'forms.address2': 'Dirección 2',
  'forms.city': 'Ciudad',
  'forms.city-message': 'Por favor seleccione una ciudad!',
  'forms.state-message': 'Por favor seleccione un estado!',
  'forms.zip': 'Código Postal',
  'forms.signup': 'Regístrate',
  'forms.inline': 'Inline',
  'forms.validation': 'Validación',
  'forms.default': 'Defecto',
  'forms.firstname': 'Nombre de Pila',
  'forms.firstname-message': '¡Por favor, introduzca su nombre de pila!',
  'forms.lastname': 'Apellido',
  'forms.lastname-message': '¡Por favor ingrese su apellido!',
  'forms.name': 'Nombre',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',

  /* 07.11.Componentes */
  'form-components.custom-inputs': 'Entrada Personalizada',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'Estado Soltero',
  'form-components.state-multiple': 'Estado Múltiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Selector de Fechas',
  'form-components.date': 'Fecha',
  'form-components.date-range': 'Rango de Fechas',
  'form-components.date-with-time': 'Fecha con Hora',
  'form-components.embedded': 'Incrustado',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Soltar Archivos Aquí',
  'form-components.tags': 'Etiquetas',
  'form-components.switch': 'Cambiar',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverso',
  'form-components.secondary-inverse': 'Secondary Inverso',
  'form-components.slider': 'Deslizador',
  'form-components.double-slider': 'Doble Deslizador',
  'form-components.single-slider': 'Único Deslizador',
  'form-components.rating': 'Clasificación',
  'form-components.interactive': 'Interactivo',
  'form-components.readonly': 'Solo Lectura',
  'form-components.type-a-cake': 'Escribe un pastel',
  'form-components.start': 'Comienzo',
  'form-components.end': 'Fin',
  'form-components.tables': 'Tablas',

  /* 07.12.Iconos */
  'icons.simplelineicons': 'Simple Line Iconos',
  'icons.iconsmind': 'Iconsmind Iconos',

  /* 07.13.Grupos de Entrada */
  'input-groups.basic': 'Básico',
  'input-groups.sizing': 'Dimensionamiento',
  'input-groups.small': 'Pequeño',
  'input-groups.default': 'Defecto',
  'input-groups.large': 'Grande',
  'input-groups.checkboxes-and-radios': 'Checkboxes y radios',
  'input-groups.multiple-inputs': 'Entradas Múltiples',
  'input-groups.first-and-last-name': 'Nombre y apellido',
  'input-groups.multiple-addons': 'Complementos Múltiples',
  'input-groups.button-addons': 'Complementos Botón',
  'input-groups.button': 'Botón',
  'input-groups.buttons-with-dropdowns': 'Botones y Desplegables',
  'input-groups.dropdown': 'Desplegable',
  'input-groups.header': 'Encabezado',
  'input-groups.action': 'Accion',
  'input-groups.another-action': 'Otra accion',
  'input-groups.custom-select': 'Personalizada Select',
  'input-groups.options': 'Opciones',
  'input-groups.choose': 'Escoger...',
  'input-groups.custom-file-input': 'Entrada de Archivo Personalizada',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': '¡Hola Mundo!',
  'jumbotron.lead':
    'Esta es una unidad de héroe simple, un componente de estilo jumbotron simple para llamar la atención extra al contenido o información destacados.',
  'jumbotron.lead-detail':
    'Utiliza clases de utilidad para tipografía y espaciado para espaciar el contenido dentro del contenedor más grande.',
  'jumbotron.learn-more': 'Aprende más',

  /* 07.15.Modal */
  'modal.basic': 'Básico',
  'modal.modal-title': 'Título Modal',
  'modal.launch-demo-modal': 'Lanzar Demo Modal',
  'modal.scrolling-long-content': 'Contenido de Desplazamiento Largo',
  'modal.backdrop': 'Fondo',
  'modal.backdrop-value': 'Valor de Fondo',
  'modal.right-modal': 'Derecha Modal',
  'modal.launch-right-modal': 'Launch Derecha Modal',
  'modal.nested-modal': 'Modal Anidado',
  'modal.size': 'Tamaño',
  'modal.launch-large-modal': 'Lanzar Grande Modal',
  'modal.launch-small-modal': 'Lanzar Pequeño Modal',

  /* 07.16.Navegación */
  'nav.basic': 'Navegación Básico',
  'nav.active': 'Activo',
  'nav.disabled': 'Discapacitado',
  'nav.disabled-link': 'Enlace Discapacitado',
  'nav.link': 'Enlace',
  'nav.longer-link': 'Enlace de navegación más largo',
  'nav.another-link': 'Otro Enlace',
  'nav.right': 'Derecha',
  'nav.dropdown': 'Desplegable',
  'nav.header': 'Encabezado',
  'nav.action': 'Accion',
  'nav.another-action': 'Otra accion',
  'nav.horizontal-alignment': 'Alineación Horizontal',
  'nav.vertical-alignment': 'Alineación Vertical',
  'nav.pills': 'Navegación Píldoras',
  'nav.fill-justify': 'Navegación Llenar y Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Paginación Básico',
  'nav.pagination-sizing': 'Paginación Dimensionamiento',
  'nav.large': 'Grande',
  'nav.small': 'Pequeño',
  'nav.center': 'Centro',
  'nav.pagination-alignment': 'Alineación de Paginación',
  'nav.breadcrumb-basic': 'Migas de Pan Básico',
  'nav.dark-mode': 'Modo Oscuro',
  'nav.log-out': 'Cerrar sesión',
  'nav.maximize': 'Maximizar',

  /* 07.17.Tooltips y Popovers */
  'popover-tooltip.popover': 'Popovers',
  'popover-tooltip.tooltip': 'Tooltips',

  /* 07.18.Ordenable */
  'sortable.columns': 'Clasificar Columnas',
  'sortable.basic': 'Básico',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Tablas Bootstrap',
  'table.bootstrap-basic': 'Tablas Básicas',
  'table.bootstrap-striped': 'Cebreadas',
  'table.bootstrap-bordered': 'Tablas Con Bordes',
  'table.bootstrap-borderless': 'Tablas Sin Bordes',
  'table.bootstrap-hoverable': 'Tablas dinámicas',
  'table.bootstrap-responsive': 'Tablas Responsive',
  'table.react-tables': 'Tablas React',
  'table.react-pagination': 'Paginación',
  'table.react-scrollable': 'Tablas Con Voluta',
  'table.react-advanced': 'Filtro, Longitud y Salto',
  'table.divided': 'Divided Table',

  /* 07.21.Wizards */
  'wizard.step-name-1': 'Paso 1',
  'wizard.step-name-2': 'Paso 2',
  'wizard.step-name-3': 'Paso 3',
  'wizard.step-desc-1': 'Descripción del primer paso',
  'wizard.step-desc-2': 'Descripción del segundo paso',
  'wizard.step-desc-3': 'Descripción del tercer paso',
  'wizard.content-1': 'Contenido para el primer paso.',
  'wizard.content-2': 'Contenido para el segundo paso.',
  'wizard.content-3': 'Contenido del último paso!',
  'wizard.content-thanks': 'Gracias!',
  'wizard.next': 'Entrante',
  'wizard.prev': 'Anterior',
  'wizard.registered': '¡Su registro se completó con éxito!',
  'wizard.async': '¡Ahorro asíncrono durante 3 segundos!',

  /* 07.22.Errors */
  'error.401-not-authorized': 'Error, sesión de usuario caducada.',
  'error.403-not-authorized':
    'Error, el usuario no tiene permiso, se recomienda volver a inciar sesión para obtener los permisos adecuados.',
  /* Modules */
  /* aiteaview_start_trans */
  'cosbim.name': 'COSBIM 360',
  'cosbim.description':
    'La inmobiliaria refente en oficinas de calidad de la zona euro',
  'menu.cities': 'Ciudades',
  'menu.administration-cosbim': 'Administración',
  'menu.buildings': 'Edificios',
  'menu.building': 'Edificio',
  'menu.widgets': 'Widgets',
  'menu.parameters': 'Parámetros',
  'menu.documents': 'Documentación',
  'menu.cosbim': 'Cosbim',
  'menu.metasys': 'Metasys',
  'menu.med': 'MED',
  'menu.alarms': 'Alarmas',
  'menu.settings': 'Configuración',
  'administration.accounts.alarms.criticity_title':
    'Niveles de Criticidad (Alarmas)',
  'administration.accounts.alarms.critical': 'Crítico',
  'administration.accounts.alarms.warning': 'Advertencia',
  'administration.accounts.alarms.minor': 'Leve',
  'administration.accounts.alarms.informational': 'Informativa',
  'administration.profile': 'Mi Perfil',
  'administration.profile.edit.success': 'Perfil actualizado correctamente',
  'administration.users': 'Usuarios',
  'administration.cities': 'Ciudades',
  'administration.buildings': 'Edificios',
  'administration.ocas': 'OCAs',
  'administration.ocas.name': 'Nombre',
  'administration.ocas.royal_decree': 'Real decreto',
  'administration.ocas.periodicity': 'Periodicidad de la inspección',
  'administration.ocas.create': 'Crear nueva instalación',
  'administration.ocas.edit': 'Editar instalación',
  'administration.ocas.inspection_name': 'Nombre de la inspección',
  'administration.ocas.royal_decree_name': 'Nombre del real decreto',
  'administration.ocas.docuware_fields': 'Campos de DocuWare',
  'administration.ocas.doc_class_field': 'Campo Clase doc',
  'administration.ocas.doc_subclass_field': 'Campo Subclase doc',
  'administration.ocas.date.missing': 'Falta',
  'administration.ocas.filter.status': 'Estado',
  'administration.ocas.filter.status.all': 'Todas las fechas',
  'administration.ocas.filter.status.danger': 'Fechas en rojo',
  'administration.ocas.filter.date': 'Fecha de inspección',
  'administration.ocas.installations': 'Instalaciones ',
  'administration.ocas.current_year': 'Año actual: ',
  'administration.ocas.download_excel': 'Descargar excel',
  'administration.ocas.building.installation': 'Instalación',
  'administration.ocas.building.regulation': 'Normativa',
  'administration.ocas.building.status': 'Estado',
  'administration.ocas.building.next_inspection': 'Próxima Inspección',
  'administration.ocas.building.status.approved': 'Aprobada',
  'administration.ocas.building.status.conditioned': 'Condicionada',
  'administration.ocas.building.status.rejected': 'No aprobada',
  'administration.ocas.building.new_inspection_date':
    'Nueva fecha de próxima inspección',
  'administration.ocas.building.conditioned_modal_title':
    'Cambiar a estado condicional',
  'administration.ocas.building.save': 'Guardar',
  'administration.widgets': 'Widgets',
  'administration.widgets.list.name': 'Nombre',
  'administration.widgets.list.url': 'URL',
  'administration.widgets.list.type': 'Tipo',
  'administration.widgets.list.placement': 'Ubicación',
  'administration.widgets.list.position': 'Posición',
  'administration.widgets.edit.tittle': 'Editar widget',
  'administration.widgets.edit.name': 'Nombre del widget',
  'administration.widgets.list.kind': 'Familia',
  'administration.widgets.edit.kind': 'Familia del widget',
  'administration.widgets.edit.type': 'Tipo de widget',
  'administration.widgets.edit.placement': 'Ubicación del widget',
  'administration.widgets.edit.position': 'Posición del widget',
  'administration.widgets.edit.url': 'URL del widget',
  'administration.widgets.edit.mobile_url': 'URL móvil del widget',
  'administration.widgets.edit.image': 'Imagen del widget',
  'administration.widgets.edit.groups': 'Grupos',
  'administration.widgets.edit.validation.error.title': 'Error de validación',
  'administration.widgets.edit.validation.error.message':
    'Por favor, complete todos los campos obligatorios, nombre, tipo, ubicación, posición y URL',
  'administration.widgets.placement': 'Ubicación',
  'administration.widgets.image': 'Seleccionar una imagen',
  'administration.widgets.portal': 'Portal',
  'administration.widgets.cosbim': 'Cosbim',
  'administration.widgets.plans': 'Planos',
  'administration.widgets.reports': 'Informes',
  'administration.widgets.heatmap': 'Mapas de calor',
  'administration.widgets.intranet': 'Intranet',
  'administration.widgets.climate': 'Clima',
  'administration.widgets.lightning': 'Iluminación',
  'administration.widgets.assistant': 'Asistente',
  'administration.widgets.electricidad': 'Electricidad',
  'administration.widgets.agua': 'Agua',
  'administration.widgets.gas': 'Gas',
  'administration.widgets.districlima': 'Districlima',
  'administration.widgets.co2': 'CO2',
  'administration.widgets.co2-ext': 'CO2 Ext.',
  'administration.widgets.cala': 'Calidad del aire',
  'administration.widgets.temperatura': 'Temperatura',
  'administration.widgets.humedad': 'Humedad',
  'administration.widgets.afluencia': 'Afluencia',
  'administration.widgets.contacts': 'Contactos',
  'administration.settings': 'Configuración',
  'administration.settings.portfolio-coords': 'Coordenadas',
  'administration.settings.latitude': 'Latitud',
  'administration.settings.longitude': 'Longitud',
  'administration.settings.market-value': 'Valor de mercado (€m)',
  'administration.settings.total-area': 'Superficie total (m²)',
  'administration.settings.total-buildings': 'Número de edificios',
  'administration.settings.portfolio-kpis': 'KPIs del portfolio',
  'administration.settings.email': 'Email de registro',
  'administration.settings.csv': 'CSV Edificios',
  'administration.settings.upload.csv.datamaster': 'Cargar CSV Datos Maestros',
  'administration.settings.upload.csv.spacesclients':
    'Cargar CSV Espacios Clientes',
  'administration.settings.uploading': 'Subiendo CSV...',
  'administration.settings.upload': 'Subir',
  'administration.settings.disclaimer.title': 'Disclaimers',
  'administration.settings.privacy.title': 'Política de privacidad',
  'administration.settings.legal.hint': 'Si se deja vacío no se muestra.',
  'administration.settings.legal.spanish': 'Texto en castellano',
  'administration.settings.legal.english': 'Texto en inglés',
  'administration.settings.legal.cat': 'Texto en catalán',
  'administration.settings.legal.french': 'Texto en francés',
  'administration.settings.contact.title': 'Contacto',
  'administration.settings.contact.hint':
    'Si se deja vacío no hay página de contacto. El formulario solo aparece con correo.',
  'administration.settings.contact.address': 'Dirección',
  'administration.settings.contact.phone': 'Teléfono',
  'administration.settings.contact.hours': 'Horario',
  'administration.settings.contact.email': 'Correo de contacto',
  'administration.settings.save': 'Guardar configuración',
  'administration.settings.scraper_config': 'Scraper KPI',
  'administration.settings.execution.title': 'Tipo de ejecución',
  'administration.settings.execution.daily': 'Diario',
  'administration.settings.execution.weekly': 'Semanal',
  'administration.settings.execution.monthly': 'Mensual',
  'administration.settings.day.week': 'Día de la semana',
  'administration.settings.day.month': 'Día del mes',
  'administration.settings.select.day': 'Seleccione un día',
  'administration.settings.notification.scraper_updated':
    'Configuración actualizada correctamente',
  'administration.settings.notification.updated': 'Configuración actualizada',
  'administration.settings.day.monday': 'Lunes',
  'administration.settings.day.tuesday': 'Martes',
  'administration.settings.day.wednesday': 'Miércoles',
  'administration.settings.day.thursday': 'Jueves',
  'administration.settings.day.friday': 'Viernes',
  'administration.settings.day.saturday': 'Sábado',
  'administration.settings.day.sunday': 'Domingo',
  'administration.scraper.save': 'Guardar configuración Scraper',
  'administration.settings.hide_scraper_config':
    'Ocultar configuración del Scraper KPI',
  'administration.settings.show_scraper_config':
    'Mostrar configuración del Scraper KPI',
  'administration.parameters': 'Parámetros',
  'administration.documents': 'Documentación',
  'administration.documents.assignment': 'Asignación de Documentación',
  'administration.documents.assign': 'Asignar',
  'administration.documents.hide': 'Ocultar',
  'administration.assign.users': 'Usuarios Asignados',
  'administration.assign.cities': 'Ciudades Asignadas',
  'administration.assign.buildings': 'Edificios Seleccionados',
  'administration.assign.widgets': 'Widgets asignados',
  'administration.assign.parameters': 'Parámetros Seleccionados',
  'administration.assign.clients': 'Clientes Asignados',
  'administration.assign.documents': 'Documentación Asignada',
  'administration.permission.user': 'Permisos',
  'administration.accounts.surname': 'Apellido',
  'administration.accounts.tittle.edit': 'Guardar usuario',
  'administration.accounts.tittle.delete': '¿Desea eliminar el usuario?',
  'administration.accounts.tittle.edit.user': 'Editar usuario',
  'administration.accounts.delete.success': 'Usuario eliminado correctamente',
  'administration.accounts.type': 'Tipo',
  'administration.accounts.auth.internal': 'Interno',
  'administration.accounts.auth.external': 'Externo',
  'administration.accounts.validated.password':
    'La contraseña debe contener al menos 8 caracteres, una letra mayúscula, un número y un carácter especial',
  'administration.accounts.selector.language': 'Idioma',
  'administration.accounts.selector.homescreen.placeholder':
    'Seleccione una página de inicio...',
  'administration.accounts.selector.homescreen.portfolio': 'Portfolio',
  'administration.accounts.selector.homescreen.space': 'Ciudad',
  'administration.accounts.selector.homescreen.building': 'Edificio',
  'administration.accounts.selector.homescreen.client': 'Cliente',
  'administration.accounts.selector.authtype': 'Tipo de Autenticación',
  'administration.accounts.selector.authtype.placeholder':
    'Seleccione tipo de autenticación...',
  'administration.accounts.selector.language.placeholder':
    'Seleccione un idioma...',
  'administration.accounts.selector.widgets.placeholder':
    'Seleccione un widget...',
  'administration.accounts.myprofile.current_password': 'Contraseña actual',
  'administration.homescreen.portofolio': 'Portfolio',
  'administration.homescreen.space': 'Ciudad',
  'administration.homescreen.building': 'Edificio',
  'administration.homescreen.client': 'Cliente',
  'administration.cities.tittle.create': 'Crear nueva ciudad',
  'administration.cities.tittle.edit': 'Guardar ciudad',
  'administration.city.tittle.delete': '¿Desea eliminar la ciudad?',
  'administration.buildings.tittle.create': 'Crear nuevo edificio',
  'administration.buildings.tittle.edit': 'Guardar edificio',
  'administration.buildings.tittle.delete': '¿Desea eliminar el edificio?',
  'administration.buildings.tittle.accept': 'Aceptar',
  'administration.buildings.image.delete': 'Eliminar imagen',
  'administration.buildings.image.delete.body':
    '¿Quieres eliminar la imagen asociada al cliente ',
  'administration.buildings.image.delete.success':
    'Imagen eliminada correctamente',
  'notification.success.title': 'Éxito',
  'administration.buildings.create.success': 'Edificio creado correctamente',
  'administration.buildings.edit.success': 'Edificio editado correctamente',
  'administration.buildings.longlat.validation':
    'El valor debe ser un número decimal con máximo 3 dígitos enteros y 7 decimales.',
  'administration.buildings.required_fields':
    'Rellena los siguientes campos obligatorios:',
  'administration.buildings.fix_errors':
    'Corrige los errores señalados antes de guardar.',
  'administration.buildings.invalid_link':
    'El link debe ser una URL válida, debe empezar por http o https.',
  'administration.buildings.tittle.warning': 'Aviso',
  'administration.buildings.tittle.cancel': 'Cancelar',
  'administration.buildings.link.grafana': 'Link Dashboard de ocupación',
  'administration.buildings.occupation': 'Datos Ocupación',
  'administration.tittle.back': 'Volver atrás',
  'administration.building.certification': 'Certificación',
  'administration.widgets.tittle.create': 'Crear nuevo widget',
  'administration.parameters.tittle.create': 'Crear nuevo parámetro',
  'administration.widgets.tittle.edit': 'Guardar widget',
  'administration.parameters.tittle.edit': 'Guardar parámetro',
  'administration.parameters.tittle.delete': '¿Desea eliminar el parámetro?',
  'administration.widgets.tittle.delete': '¿Desea eliminar el widget?',
  'administration.widgetConf.tittle.delete':
    '¿Desea eliminar la configuración del widget?',
  'administration.widgetConf.delete.success':
    'Configuración del widget eliminada correctamente',
  'administration.documents.tittle.edit': 'Guardar link',
  'administration.document.edit.success': 'Link actualizado correctamente',
  'administration.widgets.position': 'Posición en la pantalla de inicio',
  'administration.widgets.front_carusel': 'Carusel frontal',
  'administration.structure': 'Estructura',
  position: 'Posición',
  'administration.assets': 'Tipo',
  'administration.img': 'Imagen edificio',
  'administration.img.city': 'Imagen ciudad',
  'administration.img.widget': 'Imagen widget',
  'administration.widgets.url': 'URL',
  img: 'Imagen',
  'administration.accounts.superuser': 'Super usuario',
  'administration.accounts.user': 'Cliente',
  'administration.accounts.user.can.see.administration':
    'Puede ver la administración',
  'administration.groups.select-all': 'Seleccionar todo',
  'administration.groups.deselect-all': 'Limpiar',
  'administration.userRoles': 'Roles de usuario',
  'administration.selectUserRole': 'Seleccionar rol de usuario',
  'administration.selectUserRoleAssistant':
    'Debe seleccionar un rol para el widget Assistant',
  'filter.city': 'Filtrar por ciudad',
  'filter.assets': 'Filtrar por activos',
  'filter.projects': 'Filtrar por proyectos',
  'filter.buildings': 'Filtrar por edificio',
  'filter.widgets': 'Filtrar por widgets',
  'select.assets': 'Activo',
  'select.projects': 'Proyecto',
  'module.name': 'Nombre módulo',
  'parameters.name': 'Nombre parámetro',
  'parameters.name.required': 'El nombre de la carpeta es obligatorio.',
  'parameters.url': 'Link documentación',
  'document.send': 'Enviar documentación',
  'document.sending': 'Enviando correo, por favor espere...',
  'document.sent': 'Correo enviado correctamente.',
  'document.receiver': 'Receptor',
  'document.subject': 'Asunto',
  'document.comment': 'Comentario',
  'document.attached': 'Adjuntar documentos',
  'select.building': 'Seleccionar edificio',
  'url.sin.dato': '# si se trata de un contenedor de otro nivel',
  'forms.message': 'Mensaje',
  'alert.documents':
    'Para visualizar la documentación debes seleccionar un edificio.',
  'dashboard.title': 'Monitorización de energía',
  'forms.range': 'Rango de fechas',
  'forms.year-range': 'Rango de años',
  'menu.consumption': 'Consumos',
  'air.quality': 'Calidad del aire',
  'air.quality.daily': 'Calidad del aire (diario)',
  'air.quality.monthly': 'Calidad del aire (mensual)',
  'air.quality.yearly': 'Calidad del aire (anual)',
  'air.quality.ext': 'Calidad aire Ext.',
  'air.quality.history': 'Histórico Calidad del aire',
  'air.co2': 'CO2',
  'air.co2.daily': 'CO2 (diario)',
  'air.co2.monthly': 'CO2 (mensual)',
  'air.co2.yearly': 'CO2 (anual)',
  'air.co2.ext': 'CO2 Ext.',
  'air.co2.history': 'Histórico CO2',
  'air.co2.ext.history': 'Histórico CO2 Ext.',
  'carbon.footprint': 'Huella Carbono',
  'carbon.footprint.history': 'Histórico Huella de Carbono',
  'metric.temperature-forecast': 'Previsión Temperatura',
  'metric.occupation-evolution': 'Evol. ocupación',
  'metric.occupation-percentage': 'Porcentaje Afluencia',
  'metric.occupation-maximum-daily': 'Máx. Ocupación diaria',
  'metric.bathroom-transit': 'Tránsito baños',
  'metric.alarms': 'Alarmas',
  'building.flows': 'Afluencia',
  'flows.view.real': 'Vista real',
  'flows.view.max': 'Vista de máximos',
  'flows.growth.previous_year': '(Año ant.)',
  'flows.growth.range_title': 'Crecimiento de Afluencia total',
  'occupation.implantation': 'Sobre implantación',
  'occupation.max_since_january': 'Valor máximo desde el 1 de enero',
  'chart.occupation': 'Ocupación',
  'meteorology.variables.internal': 'Interior',
  'meteorology.variables.external': 'Exterior',
  'meteorology.year.to.date': 'acumulado año',
  'menu.floors': 'Plantas',
  'menu.office': 'Oficinas',
  'menu.customers': 'Clientes',
  'menu.download': 'Descargar datos en CSV',
  'gas.consumption': 'Cons. Gas',
  'gas.consumption.history': 'Histórico Consumo Gas.',
  'gas.consumption.daily': 'Cons. Gas (diario)',
  'gas.consumption.monthly': 'Cons. Gas (mensual)',
  'gas.consumption.yearly': 'Cons. Gas (anual)',
  'electrical.consumption': 'Cons. Eléct.',
  'electrical.consumption.history': 'Histórico Cons. Eléctrico',
  'electrical.consumption.daily': 'Cons. Eléct. (diario)',
  'electrical.consumption.monthly': 'Cons. Eléct. (mensual)',
  'electrical.consumption.yearly': 'Cons. Eléct. (anual)',
  'electrical.consumption.symmetrical': 'Cons. Eléct. Sim.',
  'electrical.consumption.symmetrical.history':
    'Histórico Cons. Eléctrico Simétrico',
  'electrical.consumption.symmetrical.daily': 'Cons. Eléct. Sim. (diario)',
  'electrical.consumption.symmetrical.monthly': 'Cons. Eléct. Sim. (mensual)',
  'electrical.consumption.symmetrical.yearly': 'Cons. Eléct. Sim. (anual)',
  'water.consumption': 'Cons. Agua',
  'water.consumption.history': 'Histórico Consumo Agua',
  'water.consumption.daily': 'Cons. Agua (diario)',
  'water.consumption.monthly': 'Cons. Agua (mensual)',
  'water.consumption.yearly': 'Cons. Agua (anual)',
  'districlima.consumption': 'DistriClima',
  'districlima.consumption.history': 'Histórico DistriClima',
  'districlima.consumption.daily': 'DistriClima (total) (diario)',
  'districlima.consumption.monthly': 'DistriClima (total) (mensual)',
  'districlima.consumption.yearly': 'DistriClima (total) (anual)',
  'districlima.consumption.cold': 'DistriClima (frio)',
  'districlima.consumption.cold.daily': 'DistriClima (frio) (diario)',
  'districlima.consumption.cold.monthly': 'DistriClima (frio) (mensual)',
  'districlima.consumption.cold.yearly': 'DistriClima (frio) (anual)',
  'districlima.consumption.hot': 'DistriClima (calor)',
  'districlima.consumption.hot.daily': 'DistriClima (calor) (diario)',
  'districlima.consumption.hot.monthly': 'DistriClima (calor) (mensual)',
  'districlima.consumption.hot.yearly': 'DistriClima (calor) (anual)',
  'districlima.total': 'Total',
  'districlima.hot': 'Calor',
  'districlima.cold': 'Frío',
  'chart.temperature': 'Temperatura',
  'chart.temperature.history': 'Histórico Temperatura',
  'chart.temperature.daily': 'Temperatura (diario)',
  'chart.temperature.monthly': 'Temperatura (mensual)',
  'chart.temperature.yearly': 'Temperatura (anual)',
  'chart.humidity': 'Humedad',
  'chart.humidity.ext': 'Humedad Ext.',
  'chart.humidity.history': 'Histórico Humedad',
  'chart.humidity.daily': 'Humedad (diario)',
  'chart.humidity.monthly': 'Humedad (mensual)',
  'chart.humidity.yearly': 'Humedad (anual)',
  'meteorology.temperature': 'Temperatura',
  'meteorology.humidity': 'Humedad',
  'dashboard.sub.buildings': 'Sub Edificios',
  'building.characteristics': 'Características generales',
  'city.madrid': 'Madrid',
  'city.barcelona': 'Barcelona',
  'city.paris': 'Paris',
  'floor.without.client': 'Sin Cliente',
  'building.floor.ground': 'Planta Baja',
  'building.floor.1': 'Planta 1',
  'building.floor.2': 'Planta 2',
  'building.floor.3': 'Planta 3',
  'building.floor.4': 'Planta 4',
  'building.floor.5': 'Planta 5',
  'building.floor.6': 'Planta 6',
  'building.floor.7': 'Planta 7',
  'building.blueprints': 'Planos',
  'building.reports': 'Informes',
  'building.directory': 'Directorio',
  'building.portfolio': 'Portfolio',
  'building.portfolio.group': 'Portfolio',
  'home.no-buildings': 'Todavía no tienes edificios asignados.',
  'home.no-portfolio': 'Todavía no hay ningún portfolio.',
  'aiteaview.login-sso': 'Iniciar sesión con SSO',
  'administration.search': 'Buscar...',
  'edi.nodata.available': 'No hay medición',
  'edi.connection.error': 'Error de conexión, inténtalo de nuevo',
  'edi.connection.timeout': 'Tiempo de espera agotado, inténtalo de nuevo',
  'user.forgot-password.enter.email.error':
    'Por favor, ingrese su dirección de correo electrónico',
  'user.forgot-password.invalid.email.error':
    'Dirección de correo electrónico inválida',
  'user.forgot-reset-password.forgot.password.error':
    'Error al recuperar la contraseña',
  'user.forgot-password.forgot.password.success.body':
    'Si usted es usuario de la plataforma recibirá un correo electrónico con un enlace para poder restablecer la contraseña',
  'user.forgot-password.forgot.password.success.title': 'Recuperar contraseña',
  'user.forgot-reset-password.body.title': 'LA MAGIA ESTÁ EN LOS DETALLES',
  'user.forgot-reset-password.body.body.one':
    'Si usted es usuario de la plataforma recibirá un correo electrónico con un enlace para poder restablecer la contraseña.',
  'user.forgot-reset-password.body.body.two':
    'Por favor, use su correo electrónico para restablecer su contraseña.',
  'user.forgot-reset-password.body.body.three': 'Si no es miembro, por favor',
  'user.forgot-reset-password.body.body.register': 'regístrese',
  'edi.portfolio.market.value': 'Valor de mercado',
  'edi.portfolio.total.surface.area': 'Superficie total',
  'edi.portfolio.assets.number': 'Número de activos',
  'edi.portfolio.assets.number.unit': 'inmuebles',
  'edi.nodata.to.download': 'No hay datos para descargar',
  'edi.download.minimum.period':
    'No se puede descargar datos para periodos inferiores a un mes',
  'city.madrid.directory': 'Directorio Madrid',
  'city.barcelona.directory': 'Directorio Barcelona',
  'building.floor': 'Planta',
  'building.level': 'Nivel',
  'building.floor.download.blueprint': 'Descargar',
  'building.floor.file': 'Archivo',
  'building.client': 'Cliente',
  'building.no_floors': 'No hay plantas disponibles.',
  'building.no_icon': 'Sin icono',
  'card.consumption.total': 'Total',
  'card.consumption.heating': 'Calorífico',
  'card.consumption.cooling': 'Frigorífico',
  'building.heatmap': 'Heatmap',
  'disclaimer.title': 'Aviso Importante',
  'disclaimer.button.accept': 'Aceptar',
  'disclaimer.error.get': 'Error al comprobar el estado del aviso legal',
  'disclaimer.error.accept': 'Error al guardar la aceptación del aviso legal',
  'client.apps.reports': 'Informes',
  'client.apps.heatmap': 'Mapas de calor',
  'client.apps.intranet': 'Intranet',
  'client.apps.climate': 'Clima',
  'client.apps.lightning': 'Iluminación',
  'administration.buildings.without.img': 'Sin imagen',
  'building.blueprint.implantation': 'Implantación',
  'building.blueprint.architecture': 'Arquitectura',
  'building.blueprint.coordination.imp': 'Coordination Imp.',
  'building.blueprint.coordination.arch': 'Coordination Arq.',
  'building.apps': 'Apps',
  'contact.with.us': 'Contacta con nosotros',
  'building.blueprint.coordination': 'Coordinación',
  'administration.settings.autodesk.title': 'Autodesk',
  'administration.settings.set.period.time':
    'Establecer periodo de descarga autodesk (horas)',
  'administration.settings.set.period.time.visualization':
    'Establecer periodo de visualización autodesk (días)',
  'administration.accounts.autodesk_id': 'ID Autodesk',
  'administration.settings.footprint_objective':
    'Objetivo de huella de carbono',
  'edi.dashboard.widgets.edit-chart': 'Editar gráfica',
  'administration.settings.report_config': 'Configuración avanzada del informe',
  'administration.settings.manage_reports': 'Gestionar informes',
  'settings.report.lang.es': 'Español',
  'settings.report.lang.fr': 'Francés',
  'settings.report.lang.cat': 'Catalán',
  'settings.report.lang.en': 'Inglés',
  'date.sunday': 'Domingo',
  'date.monday': 'Lunes',
  'date.tuesday': 'Martes',
  'date.wednesday': 'Miércoles',
  'date.thursday': 'Jueves',
  'date.friday': 'Viernes',
  'date.saturday': 'Sábado',
  'date.january': 'Enero',
  'date.february': 'Febrero',
  'date.march': 'Marzo',
  'date.april': 'Abril',
  'date.may': 'Mayo',
  'date.june': 'Junio',
  'date.july': 'Julio',
  'date.august': 'Agosto',
  'date.september': 'Septiembre',
  'date.october': 'Octubre',
  'date.november': 'Noviembre',
  'date.december': 'Diciembre',
  'dashboard.hide_reports_config': 'Ocultar configuración de informes',
  'dashboard.show_reports_config': 'Mostrar configuración de informes',
  'administration.widgets.flows': 'Flujos',
  'administration.widgets.deepki': 'Deepki',
  'administration.widgets.med': 'MED',
  'administration.widgets.metasys_barcelona': 'Metasys Barcelona',
  'administration.widgets.metasys_madrid': 'Metasys Madrid',
  'administration.widgets.aitea_building': 'Edificio Aitea',
  'administration.reports.title-1': 'Título 1',
  'administration.reports.title-2': 'Título 1.1',
  'administration.reports.title-3': 'Título 1.1.1',
  'administration.reports.title-4': 'Título 1.1.1.1',
  'administration.reports.title-5': 'Título 1.1.1.1.1',
  'administration.reports.title-6': 'Título 1.1.1.1.1.1',
  'administration.reports.text-body': 'Cuerpo de texto',
  'administration.reports.table-chart-title': 'Título de tablas y gráficas',
  'building.basement': 'Sótano',
  'building.semi_basement': 'Semisótano',
  'building.garage': 'Garaje',
  'building.attic': 'Ático',
  'building.mezzanine': 'Entreplanta',
  'chart.unconsolidated-data': 'Mes en curso',
  'chart.previous-year': 'Año anterior',
  'chart.no-data': 'No hay datos para mostrar',
  'chart.loading': 'Cargando...',
  'chart.target': 'Objetivo 2030',
  'chart.maximum': 'Máximo',
  'chart.minimum': 'Mínimo',
  'chart.co2-rite': 'CO2 valor referencia máximo',
  'edi.widgets.chart-edi': 'Gráfica AiteaView',
  'administration.building.no_certificates': 'No hay certificados asignados',
  'administration.permission.admin': 'Administrador',
  'administration.widgets.placement.carousel': 'Carrusel',
  'administration.widgets.placement.information': 'Información',
  'administration.widgets.placement.directory': 'Directorio',
  'administration.widgets.placement.data': 'Datos',
  'administration.group.all': 'Todos',
  'administration.group.building': 'Edificio',
  'administration.group.subbuilding': 'Sub edificio',
  'administration.group.client': 'Cliente',
  'chart.humidity-rite': 'Máximo Real Decreto 486/1997',
  'chart.humidity-min-rite': 'Mínimo Real Decreto 486/1997',
  'cosbim.parameters.not-configured':
    'Este edificio todavía no tiene carpetas configuradas.',
  'cosbim.documents.not.found': 'No hay documentos en este módulo',
  'cosbim.open.all.nodes': 'Abrir todas las carpetas',
  'cosbim.close.all.nodes': 'Cerrar todas las carpetas',
  'cosbim.pdf': 'PDF',
  'cosbim.cad': 'CAD',
  'cosbim.docuware.no-ue-code':
    'Este edificio no tiene código de unidad económica, que es lo que lo identifica en DocuWare. Sin él no se pueden mostrar sus documentos.',
  'cosbim.building.not-found':
    'No se ha encontrado el edificio. Comprueba el enlace: esta pantalla solo muestra edificios.',
  'cosbim.docuware.forbidden':
    'No tienes permiso para ver los documentos de este edificio.',
  'cosbim.docuware.unreachable':
    'No hay conexión con DocuWare. Las carpetas se muestran vacías hasta que vuelva el servicio.',
  'cosbim.docuware.error':
    'DocuWare ha devuelto un error. Las carpetas se muestran vacías, pero puede que sí tengan documentos.',
  'cosbim.docuware.downloading': 'Descargando...',
  'cosbim.docuware.view': 'Ver el documento',
  'cosbim.docuware.download': 'Descargar el documento',
  'cosbim.docuware.not_viewable':
    'Este documento no se puede ver en el navegador; se descarga con el icono.',
  'cosbim.docuware.viewer.close': 'Cerrar',
  'cosbim.docuware.viewer.unsupported':
    'Este documento no se puede mostrar aquí; descárgalo para abrirlo.',
  'cosbim.docuware.download_failed': 'No se ha podido descargar el documento',
  'cosbim.docuware.view_failed': 'No se ha podido abrir el documento',
  'cosbim.docuware.retry': 'Reintentar',
  'cosbim.docuware.truncated':
    'Hay más documentos de los que DocuWare devuelve de una vez, así que puede faltar alguno en la lista.',
  'cosbim.docuware.folder.loading': 'Cargando documentos...',
  'cosbim.docuware.folder.unavailable': 'No disponible',
  'cosbim.bim.load_failed': 'No se han podido cargar los documentos de BIM360.',
  'cosbim.bim.cache_unavailable': 'Caché de Autodesk no disponible.',
  'cosbim.bim.download_failed':
    'No se ha podido descargar el archivo de BIM360.',
  'cosbim.node.without_name': 'Sin nombre',
  'parameters.hidden.success': 'Carpeta ocultada',
  'parameters.visible.success': 'Carpeta visible',
  'documents.empty.links':
    'Este edificio no tiene ninguna carpeta de tipo Link, que son las únicas que se configuran aquí.',
  'documents.empty.no_cosbim': 'Este edificio no tiene módulo COSBIM asociado.',
  'building.autodesk-id-missing':
    'El Edificio no tiene ID de Autodesk configurado.',
  'building.contacts': 'Contactos',
  'building.information': 'Información del edificio',
  'building.services': 'Servicios',
  'building.validations': 'Validaciones',
  'building.contacts.last.update': 'Última actualización',
  'building.create.service': 'Crear nuevo servicio',
  'building.create.validation': 'Crear nueva validación',
  'building.edit.service': 'Editar servicio',
  'building.edit.validation': 'Editar validación',
  'building.service.name': 'Nombre',
  'building.service.description': 'Descripción',
  'building.validation.service': 'Servicio',
  'building.validation.field': 'Campo',
  'building.validation.type': 'Tipo',
  'building.ue_code': 'Código UE',
  'building.tipology': 'Tipología',
  'building.status': 'Estado',
  'building.parent_space': 'Ciudad',
  'building.basic_data': 'Datos básicos',
  'building.tipology.monousuario': 'Monousuario',
  'building.tipology.multiusuario': 'Multiusuario',
  'building.tipology.en_construction': 'En construcción',
  'building.status.requerimiento': 'Requerimiento',
  'building.status.explotacion': 'Explotación',
  'building.status.fin_de_obra': 'Fin de obra',
  'building.contact.tecnico': 'Técnico Asociado',
  'building.contact.csm': 'CSM Asociado',
  'building.contact.fm': 'Facility Manager',
  'building.contact.name': 'Nombre',
  'building.contact.email': 'Correo',
  'building.contact.phone': 'Teléfono',
  'building.contact.company': 'Compañía',
  'building.contact.24h.ssgg': 'Contacto 24h SSGG',
  'building.contact.24h.pci': 'Contacto PCI 24h',
  'building.contact.24h.vertical_transport': 'Telf 24h Transporte Vertical',
  'building.contact.24h.medium_voltage': 'Contacto 24h Media Tensión',
  'building.contact.24h.security_phone': 'Teléfono seguridad 24H',
  'building.contact.24h.vigilance': '24h Vigilancia',
  'building.contact.24h': '24 Horas',
  'building.phone.hours': 'Teléfono 24 horas',
  'building.phone.hours.other': 'Teléfono 24 horas (otro)',
  'building.contact.technician': 'Técnico',
  'building.contact.coordinator': 'Coordinador',
  'building.phone.other': 'Otro Teléfono',
  'building.shift': 'Turno',
  'building.notes': 'Observaciones',
  'administration.services.tittle.delete': '¿Desea borrar este servicio?',
  'administration.contacts.tittle.delete':
    '¿Está seguro de borrar este contacto?',
  'administration.settings.verification.title': 'Validaciones contactos',
  'administration.settings.verification.enabled':
    'Activar sistema de verificación',
  'administration.settings.verification.max.days':
    'Días máximos de confirmación',
  'administration.settings.verification.periodicity.days':
    'Periodicidad de validaciones (días)',
  'building.contacts.add.technician': 'Añadir contacto',
  'building.contacts.delete.contact': 'Borrar contacto',
  'technician.created.success': 'Contacto creado correctamente',
  'service.updated.success': 'Editado correctamente',
  'service.deleted.success': 'Borrado correctamente',
  'service.created.success': 'Creado correctamente',
  'administration.validations.tittle.delete':
    '¿Está seguro de borrar esta validación?',
  'email.verification.success': 'Correo verificado correctamente',
  'email.verification.error': 'No se pudo verificar el correo',
  'email.verification.go_to_login': 'Ir al login',
  'administration.contacts.permissions.title': 'Permisos de contactos',
  'administration.contacts.permissions.read': 'Lectura',
  'administration.contacts.permissions.write': 'Escritura',
  'administration.contacts.permissions.validate': 'Validación',
  'building.validate.data': 'Validar datos',
  'administration.settings.validation.period.days':
    'Periodicidad de validación de datos (días)',
  'alarms.no.registred': 'No hay alarmas registradas',
  'alarms.non.critical': 'No crítica',
  'alarms.critical': 'Crítica',
  'alarms.without.message': 'Sin mensaje',
  'assistant.ask': 'Pregúntame lo que quieras...',
  'assistant.loading': 'Cargando asistente...',
  'assistant.location.portfolio': 'Estás consultando el portfolio de [name].',
  'assistant.location.city': 'Estás consultando los edificios de [name].',
  'assistant.location.building': 'Estás consultando [name].',
  'building.form.cups': '+ Añadir CUPS',
  'building.form.ue_code': '+ Añadir código UE',
  'building.subbuildings.ue_codes': 'Códigos UE de subedificios',
  'building.generate.reports': 'Generar informe',
  'building.report.consumption.only.building.or.client.message':
    'Solo se puede generar el informe de consumo desde un edificio o un cliente',
  'consumption.report.send': 'Enviar',
  'date.range.invalid': 'El rango de fechas no es válido',
  'consumption.report.missing_data': 'Faltan datos de edificio o cliente',
  'consumption.report.success': 'Informe generado correctamente',
  'consumption.report.generating': 'Generando informe...',
  'consumption.report.no_cups':
    'Este informe no puede ser generado en este edificio al ser un edificio de baja tensión.',
  'consumption.report.email_sent':
    'Informe enviado correctamente por correo electrónico.',
  'building.data_validated': 'Validado',
  'building.last_validated_at': 'Fecha de última validación',
  'building.last_validated_by': 'Validado por',
  'carbon.footprint.message':
    'Emisiones operacionales del Scope 1 + 2 + 3 según Greenhouse Gas Protocol (GHG Protocol) en su metodología oficial de cálculo market-based.',
  'building.contact.role': 'Rol',
  'contacts.download.title': 'Generar Excel de Contactos',
  'contacts.download.select.buildings': 'Selecciona edificios a incluir:',
  'contacts.download.select.all': 'Seleccionar todo',
  'contacts.download.download': 'Descargar',
  'contacts.download.send': 'Enviar',
  'contacts.download.no.buildings': 'Selecciona al menos un edificio',
  'contacts.download.success': 'Excel de contactos descargado correctamente',
  'contacts.download.email.sent':
    'Listado de contactos enviado correctamente por correo',
  'parameters.name.duplicated':
    'Ya existe una carpeta con ese nombre en el mismo nivel.',
  'parameters.name.too_long':
    'La ruta completa supera los 200 caracteres. Acorta el nombre.',
  'parameters.path.preview': 'Ruta completa',
  'parameters.node_type': 'Tipo de parámetro',
  'parameters.node_type.container': 'Contenedor',
  'parameters.node_type.docuware': 'Contenedor DocuWare',
  'parameters.node_type.autodesk': 'Contenedor AutoDesk',
  'parameters.node_type.link': 'Link',
  'parameters.node_type.link_hint':
    'Un Contenedor solo agrupa: para mostrar documentos, elige Contenedor DocuWare. Un Link no admite subcarpetas.',
  'parameters.node_type.link_has_children':
    'No se puede convertir en Link: la carpeta tiene subcarpetas.',
  'parameters.node_type.drop_filter':
    'Al cambiar el tipo se eliminará el filtro de DocuWare.',
  'parameters.docuware.cabinet': 'Archivador',
  'parameters.docuware.cabinet_required': 'Elige un archivador.',
  'parameters.docuware.cabinet_unavailable':
    'No se ha podido cargar la lista de archivadores.',
  'parameters.docuware.clase_doc': 'Clase doc',
  'parameters.docuware.subclase_doc': 'Subclase doc',
  'parameters.docuware.tipo_doc': 'Tipo doc',
  'parameters.filter.add': 'Añadir',
  'parameters.filter.placeholder': 'Escribe un valor y pulsa Intro',
  'parameters.filter.any_of':
    'Con varios valores en un mismo campo se muestran los documentos de cualquiera de ellos. Los campos entre sí se cumplen todos.',
  'parameters.docuware.values_empty':
    'Estos valores no aparecen hoy en ningún documento, puede ser una errata o que todavía no haya nada cargado con ese valor: {values}',
  'parameters.docuware.filter_empty':
    'Un filtro sin ningún valor mostraría todos los documentos del edificio.',
  'parameters.docuware.checking': 'Comprobando en DocuWare...',
  'parameters.docuware.ok': 'El filtro devuelve {count} documentos.',
  'parameters.docuware.no_match':
    'El archivador tiene {count} documentos del ámbito, pero ninguno cumple este filtro.',
  'parameters.docuware.field_empty':
    'Este campo es el que deja el filtro vacío.',
  'parameters.docuware.empty_scope':
    'Todavía no hay documentos en este ámbito, así que no se puede comprobar el filtro.',
  'parameters.docuware.unreachable': 'No hay conexión con DocuWare.',
  'parameters.docuware.gateway_error': 'DocuWare ha devuelto un error.',
  'parameters.docuware.no_ue_code':
    'El edificio no tiene código de unidad económica.',
  'parameters.docuware.saves_anyway': 'La carpeta se guarda igualmente.',
  'parameters.docuware.save_anyway': 'Guardar de todos modos',
  'parameters.docuware.save_unchecked': 'Guardar sin comprobar',
  'parameters.reorder.up': 'Subir',
  'parameters.reorder.down': 'Bajar',
  'parameters.empty': 'Todavía no hay carpetas.',
  'parameters.empty.search': 'Ningún parámetro coincide con la búsqueda.',
  'parameters.created.success': 'Carpeta creada correctamente',
  'parameters.updated.success': 'Carpeta actualizada correctamente',
  'parameters.deleted.success': 'Carpeta eliminada correctamente',
  'administration.widgets.planos': 'Planos',
  'client.reports.floors.title': 'Seleccione las plantas',
  'client.reports.floors.empty':
    'No hay plantas disponibles para este cliente.',
  'client.reports.floors.required': 'Seleccione al menos una planta',
  'client.reports.dashboard.required': 'Seleccione un informe',
  'client.reports.confirm': 'Confirmar',
  'client.reports.cancel': 'Cancelar',
  'client.reports.generate.pdf': 'Generar PDF',
  'client.reports.send.email': 'Enviar por correo',
  'client.reports.selected.floors': 'Plantas seleccionadas',
  'date.range.same.year': 'Solo se pueden elegir meses del mismo año',
  'client.reports.generating': 'Generando informe...',
  'client.reports.pdf.success': 'Informe generado correctamente',
  'client.reports.email.success': 'Informe enviado a tu correo',
  'client.reports.email.sending': 'Enviando el informe...',
  'client.reports.pdf.error': 'No se ha podido generar el informe',
  'client.reports.floors.resolving': 'Preparando las plantas...',
  'client.reports.floors.error':
    'No se han podido resolver las plantas del informe',
  'client.reports.module.on-floor': 'En planta',
  'client.reports.module': 'Módulo',
  'widgets.type.date': 'Fecha',
  'widgets.type.apps-carousel': 'Carrusel de aplicaciones',
  'widgets.type.apps-directory': 'Directorio de aplicaciones',
  'widgets.type.portfolio-summary': 'Resumen del portfolio',
  'widgets.type.weather': 'Tiempo',
  'widgets.type.air-quality': 'Calidad del aire exterior',
  'widgets.type.metric': 'Métrica',
  'widgets.type.app': 'Aplicación',
  'widgets.kind.url': 'Enlace (url)',
  'widgets.kind.data': 'Datos (data)',
  'widgets.kind.custom': 'Propio (custom)',
  'widgets.kind.custom-app': 'Aplicación con interfaz propia',
  'widgets.behavior.link': 'Enlace',
  'widgets.behavior.blueprint': 'Planos',
  'widgets.behavior.reports': 'Informes',
  'widgets.behavior.contacts': 'Contactos',
  'widgets.behavior.contacts_download': 'Descarga de contactos',
  'widgets.behavior.cosbim': 'COSBIM',
  'widgets.behavior.ocas': 'OCAs',
  'widgets.behavior.assistant': 'Asistente',
  'widgets.config.behavior': 'Comportamiento',
  'widgets.config.node_types': 'Se ofrece en',
  'widgets.config.required_permission': 'Permiso requerido',
  'widgets.node_type.portfolio': 'Portfolio',
  'widgets.node_type.space': 'Espacio o ciudad',
  'widgets.node_type.building': 'Edificio',
  'widgets.node_type.subbuilding': 'Subedificio',
  'widgets.node_type.client': 'Cliente',
  'widgets.public': 'Público',
  'widgets.public.help':
    'Lo ve cualquier usuario con acceso a la entidad, sin necesitar el permiso del widget. Hay que asignarlo igualmente a cada entidad.',
  'administration.ocas.filter.status.danger_warning':
    'Fechas en rojo y amarillo',
  'administration.ocas.docuware_pending':
    'La fuente de documentos (DocuWare) está pendiente de configurar: hasta entonces las instalaciones figuran como «Pendiente» y sin documento.',
  'administration.ocas.building.no_document': 'Sin Documento',
  'administration.ocas.building.last_sync': 'Datos de DocuWare del',
  'administration.ocas.building.sync_error':
    'No se ha podido conectar con DocuWare. Se muestran los últimos datos disponibles.',
  'administration.ocas.tittle.delete':
    '¿Está seguro de borrar esta instalación?',
  'administration.ocas.month': 'mes',
  'administration.ocas.months': 'meses',
  'administration.ocas.building.status.not_applicable': 'N/A',
  'administration.ocas.date.not_applicable': 'N/A',
  'administration.ocas.date.pending': 'Pendiente',
  'administration.ocas.building.status.pending': 'Pendiente',
  'administration.settings.ocas.title': 'Avisos por correo de las OCAs',
  'administration.settings.ocas.enabled': 'Activar los avisos de OCAs',
  'administration.settings.ocas.expiry_days':
    'Días de antelación del aviso de vencimiento',
  'administration.settings.ocas.periodicity_days':
    'Días entre avisos repetidos',
  'administration.settings.ocas.help':
    'Con los avisos activados, AiteaView manda a diario un correo a los FMs por cada edificio con inspecciones próximas a vencer, y a los FMs y al técnico del edificio cuando hay inspecciones no aprobadas.',
  'administration.settings.ocas.save': 'Guardar avisos de OCAs',
  'administration.settings.notification.ocas_updated':
    'Avisos de OCAs actualizados correctamente',
  /* aiteaview_end_trans */
  /* aiteaassistant_start_trans */
  'example.example': 'Ejemplo',
  'assistant.title': 'Aitea Assistant',
  'assistant.say.something': 'Pregúntame algo',
  'assistant.action.delete': 'Eliminar',
  'assistant.action.speaker': 'Conectar con altavoz',
  'assistant.action.microphone': 'Conectar con micrófono',
  'assistant.action.microphonestop': 'Pausar micrófono',
  'assistant.action.attach': 'Adjuntar documentos',
  'assistant.action.alerts': 'Agregar alertas',
  'assistant.action.settings': 'Ajustes',
  'assistant.action.logout': 'Cerrar sesión',
  'assistant.menu': 'Assistant',
  'assistant.initial.message': 'Hola de nuevo',
  'assistant.greeting':
    'Hola, [name]. Soy tu Asistente, la herramienta que permite acceder de forma ágil y sencilla a la información clave del portfolio de Colonial, mejorar los KPI de mantenimiento, ahorrar tiempo en las gestiones diarias y servir de soporte para el control de calidad del mantenimiento operativo.',
  'assistant.file.download': 'Descargar documento solicitado',
  'assistant.file.error':
    'Error al descargar el archivo, Los archivos solo se puede descargar una vez. Para volver a visualizarlo, hay que solicitarlo de nuevo.',
  'assistant.user.pronoun': 'Yo',
  'assistant.delete.disclaimer':
    '¿Estas seguro de querer eliminar la conversación?',
  'assistant.delete.title': 'Eliminar historial de la conversación',
  'assistant.yesterday': 'Ayer',
  'assistant.today': 'Hoy',
  'assistant.thinking': 'Pensando...',
  'assistant.listening': 'Escuchando...',
  'assistant.playing': 'Reproduciendo...',
  'assistant.playback.speed': 'Velocidad de reproducción',
  'assistant.playback.close': 'Cerrar reproductor',
  'assistant.finish': 'Finalizar',
  'assistant.reasoning': 'Razonamiento',
  'assistant.feedback.title': '¿Cómo fue esta respuesta?',
  'assistant.feedback.comment.placeholder': 'Comentario (opcional)',
  'assistant.feedback.submit': 'Enviar',
  'permissions.global.assistant.use': 'Usar el asistente',
  'permissions.global.assistant.use.description':
    'Preguntar al asistente y consultar el historial de chats propio.',
  'permissions.global.assistant.chatbot': 'Asistente en modo chatbot',
  'permissions.global.assistant.chatbot.description':
    'Usar el asistente como chatbot: responde a las preguntas.',
  'permissions.global.assistant.agentic': 'Asistente en modo agéntico',
  'permissions.global.assistant.agentic.description':
    'Usar el asistente en modo agéntico: además de responder, ejecuta acciones.',
  /* aiteaassistant_end_trans */
  /* dashboards_start_trans */
  'menu.dashboardList': 'Lista de Dashboard',
  'dashboard.name': 'Nombre del Dashboard',
  'dashboard.description': 'Descripción del Dashboard',
  'dashboard.widgets': 'Widgets',
  'dashboard.widgets.chart-line': 'Gráfica de líneas',
  'dashboard.widgets.chart-area': 'Gráfica de áreas',
  'dashboard.widgets.chart-column': 'Gráfica de columnas',
  'dashboard.widgets.table': 'Tabla',
  'dashboard.widgets.counter': 'Contador',
  'dashboard.widgets.title': 'Título',
  'dashboard.widgets.text': 'Texto',
  'dashboard.widgets.chart-abscissa': 'Gráfica de abscisas',
  'dashboard.widgets.chart-pie': 'Gráfica de secciones',
  'dashboard.widgets.chart-bar-electric-use': 'Gráfica de barras %',
  'dashboard.widgets.electric-use.types': 'Datos a mostrar',
  'dashboard.widgets.electric-use.power': 'Fuerza',
  'dashboard.widgets.electric-use.lighting': 'Alumbrado',
  'dashboard.widgets.electric-use.hvac': 'Clima',
  'dashboard.widgets.electric-use.validation-error':
    'Tienes que elegir al menos un tipo de dato y la agrupación de los datos.',
  'dashboard.widgets.electric-use.no-entity':
    'Este widget necesita abrirse desde un edificio, subedificio o cliente.',
  'dashboard.widgets.electric-use.no-module':
    'Esta entidad no tiene el módulo Electricidad Uso con la agrupación elegida.',
  'dashboard.widgets.create': 'Crear nuevo widget',
  'dashboard.widgets.name': 'Nombre del Widget',
  'dashboard.widgets.database': 'Base de Datos',
  'dashboard.widgets.collector': 'Colector',
  'dashboard.widgets.counter.type': 'Tipo de valor',
  'dashboard.widgets.counter.type.max': 'Valor máximo',
  'dashboard.widgets.counter.type.last': 'Ultimo valor',
  'dashboard.widgets.content': 'Contenido del widget',
  'dashboard.widgets.content.edit': 'Editar contenido',
  'dashboard.widgets.save': 'Guardar',
  'dashboard.widgets.delete': 'Borrar',
  'dashboard.widgets.cancel': 'Cancelar',
  'dashboard.widgets.add': 'Añadir',
  'dashboard.widgets.delete-confirmation': '¿Estás seguro de borrar el widget?',
  'dashboard.widgets.close-confirmation':
    '¿Estás seguro de salir? Si tienes cambios sin guardar se perderán.',
  'dashboard.widgets.select': 'Selecciona el tipo de Widget',
  'dashboard.widgets.select.columns': 'Maximo de columnas',
  'dashboard.widgets.select-type.electrical': 'Eléctrico',
  'dashboard.widgets.select-type.water': 'Agua',
  'dashboard.widgets.select-type.gas': 'Gas',
  'dashboard.widgets.select-type.thermal-cold': 'Térmico (frio)',
  'dashboard.widgets.select-type.thermal-hot': 'Térmico (calor)',
  'dashboard.widgets.select-type.thermal-total': 'Térmico total',
  'dashboard.widgets.select-type.occupation-percentage': 'Porcentaje Ocupación',
  'dashboard.widgets.select-type.temperature': 'Temperatura',
  'dashboard.widgets.select-type.ext-temperature': 'Temperatura Ext.',
  'dashboard.widgets.select-type.humidity': 'Humedad',
  'dashboard.widgets.select-type.ext-humidity': 'Humedad Ext.',
  'dashboard.widgets.select-type.co2': 'CO2',
  'dashboard.widgets.select-type.ext-co2': 'CO2 Ext.',
  'dashboard.widgets.select-type.cala': 'Calidad del aire',
  'dashboard.widgets.select-group.hourly': 'Horario',
  'dashboard.widgets.select-group.daily': 'Diario',
  'dashboard.widgets.select-group.monthly': 'Mensual',
  'dashboard.widgets.select-group.yearly': 'Anual',
  'dashboard.widgets.select-type.title-warning':
    'Advertencia de tipo de agrupación',
  'dashboard.widgets.select-type.body-warning':
    'El tipo de dato que seleccionaste solo contiene datos por hora, el widget estará vacío.',
  'dashboard.widgets.date.from': 'Desde',
  'dashboard.widgets.date.to': 'Hasta',
  'dashboard.widgets.text.header': 'Widget Texto',
  'dashboard.widgets.title.header': 'Widget Título',
  'dashboard.widgets.module.title-error': 'Error del módulo',
  'dashboard.widgets.module.body-error':
    'El colector {collectorType} {collectorGroupingType} del widget {widgetName} no existe en {representName}.',
  'dashboard.widgets.multi.edit-chart': 'Editar gráfica',
  'dashboard.widgets.multi.content': 'Creación de gráfica de abscisas',
  'dashboard.widgets.multi.title': 'Titulo',
  'dashboard.widgets.multi.footer': 'Pie',
  'dashboard.widgets.multi.components': 'Componentes',
  'dashboard.widgets.multi.component': 'Componente',
  'dashboard.widgets.multi.edit': 'Editar',
  'dashboard.widgets.multi.delete': 'Borrar',
  'dashboard.widgets.multi.edit-component': 'Editar componente',
  'dashboard.widgets.multi.component-name': 'Nombre del componente',
  'dashboard.widgets.multi.chart-type': 'Tipo de gráfica',
  'dashboard.widgets.multi.source': 'Fuente',
  'dashboard.widgets.multi.color': 'Color',
  'dashboard.widgets.multi.lines': 'Líneas',
  'dashboard.widgets.multi.line': 'Línea',
  'dashboard.widgets.multi.columns': 'Columnas',
  'dashboard.widgets.multi.min': 'Mínimo',
  'dashboard.widgets.multi.mean': 'Media',
  'dashboard.widgets.multi.max': 'Máximo',
  'dashboard.widgets.multi.default': 'Por defecto',
  'dashboard.widgets.multi.stacked-percentage':
    'Gráfica apilada con porcentajes',
  'dashboard.widgets.multi.total-grouped':
    'Gráfica de totales agrupados por componente',
  'dashboard.widgets.multi.last-year-compare': 'Comparativa año anterior',
  'dashboard.widgets.donut.content': 'Creación de gráfica de secciones',
  'dashboard.widgets.collector-type': 'Tipo de datos',
  'dashboard.widgets.collector-grouping-type': 'Agrupación de los datos',
  'dashboard.widgets.edi.template-warning':
    'Modo edición, este Dashboard es una plantilla de informe, para ver los datos acceda desde EDI.',
  'dashboard.widgets.edi.template-error':
    'Este dashboard es una plantilla de informe, acceda desde EDI para visualizar los datos.',
  'dashboards.create-dashboard': 'Crear',
  'dashboards.create-button': 'Nuevo Dashboard',
  'dashboards.create-dashboard.title': 'Crear Nuevo Dashboard',
  'dashboards.new-dashboard-name': 'Nombre del dashboard',
  'dashboards.modify-dashboard': 'Modificar',
  'dashboards.update-dashboard-name': 'Modificar nombre',
  'dashboard.widgets.table.title': 'Tabla',
  'dashboard.widgets.table.columns': 'Columnas',
  'dashboard.widgets.table.add.column': 'Agregar Columna',
  'dashboard.widgets.table.rows': 'Filas',
  'dashboard.widgets.table.add.row': 'Agregar Fila',
  'dashboard.widgets.table.footer': 'Pie de página',
  'dashboard.widgets.table.configure': 'Configurar',
  'dashboard.widgets.table.type': 'Tipo',
  'dashboard.widgets.table.type.horizontal': 'Horizontal',
  'dashboard.widgets.table.type.vertical': 'Vertical',
  'dashboard.widgets.table.color.first.row': 'Color de la Primera Fila',
  'dashboard.widgets.table.color.other.rows': 'Color Otras Filas',
  'dashboard.widgets.table.color.other.cols': 'Color Otras Columnas',
  'dashboard.widgets.table.compare.hide.months': 'Ocultar meses',
  'dashboard.widgets.table.validation.stats-required':
    'Debes seleccionar al menos una opción en Otras filas o en Otras columnas',
  'dashboard.widgets.table.color.conditioned': 'Color Condicionado',
  'dashboard.widgets.table.condition': 'Condición',
  'dashboard.widgets.table.others.rows': 'Otras Filas',
  'dashboard.widgets.table.others.columns': 'Otras Columnas',
  'dashboard.widgets.table.compare.last.year': 'Comparar con el Año Anterior',
  'dashboard.widgets.table.max': 'Máximo',
  'dashboard.widgets.table.minimun': 'Mínimo',
  'dashboard.widgets.table.average': 'Promedio',
  'dashboard.widgets.table.configuration': 'Configurar',
  'dashboard.widgets.table.title-placeholder': 'Título',
  'dashboard.widgets.table.footer-placeholder': 'Pie',
  'dashboard.widgets.table.condition-placeholder':
    'Ej: valor > 27 || valor < 17',
  'dashboard.create.report_properties': 'Propiedades del informe',
  'dashboard.create.report_description': 'Descripción',
  'dashboard.create.report_format':
    'Añadir formato de informe (portada, índice, encabezado y pie de página)',
  'dashboard.create.report_image1': 'Imagen 1 (derecha del pie de página)',
  'dashboard.create.report_image2': 'Imagen 2 (derecha del encabezado)',
  'dashboard.create.report_image3': 'Imagen 3 (centro de la portada)',
  'dashboard.report-image.low-resolution.title': 'Resolución de imagen baja',
  'dashboard.report-image.low-resolution.body':
    'La resolución de la imagen seleccionada es inferior a la recomendada y puede afectar a su calidad de visualización en el informe. Se recomienda utilizar una imagen de mayor resolución.',
  'dashboard.create.report_clients': 'Visible para clientes',
  'dashboard.create.report_disclaimer': 'Texto Disclaimer',
  'dashboard.pdf': 'PDF',
  'dashboard.generate.pdf': 'Generar',
  'dashboard.mail': 'Mail',
  'dashboard.send.mail': 'Enviar',
  'dashboard.send_mail': 'Enviar a mi correo',
  'dashboard.close': 'Cerrar',
  'dashboard.create.add_cover_page': 'Añadir portada',
  'dashboard.create.add_index_page': 'Añadir índice',
  'dashboard.create.add_header': 'Añadir encabezado',
  'dashboard.create.add_footer': 'Añadir pie de página',
  'dashboard.create.report_disclaimer_two': 'Texto Disclaimer 2',
  'dashboard.title.data.quality': 'Calidad del dato',
  'dashboard.title.forced.points': 'Puntos en forzado manual',
  'dashboard.title.points.outside.rite': 'Puntos fuera de RITE',
  'dashboard.title.vrvs.alarms': 'VRVs con alarma de filtro',
  'dashboard.title.data.frequency':
    'Análisis de frecuencia de recogida del dato',
  'dashboard.title.abnormal.electrical.consumption':
    'Consumos eléctricos anómalos',
  'dashboard.title.startup.recommendation': 'Recomendación de Arranque',
  'dashboard.create.corporate_text': 'Texto corporativo',
  'dashboard.dashboards.delete-confirmation':
    '¿Está seguro de borrar este informe?',
  'dashboard.save.success': 'El dashboard se ha guardado correctamente.',
  'dashboard.table.total': 'Total',
  'dashboard.table.total.accumulated': 'Total Acumulado',
  'dashboard.table.min': 'Mínimo',
  'dashboard.table.avg': 'Media',
  'dashboard.table.stat': 'Estadística',
  'dashboard.table.year': 'Año',
  'dashboard.table.month': 'Mes',
  'dashboard.table.value': 'Valor',
  'dashboard.table.floor': 'Planta',
  'dashboard.table.module': 'Módulo',
  'dashboard.month.short.jan': 'Ene',
  'dashboard.month.short.feb': 'Feb',
  'dashboard.month.short.mar': 'Mar',
  'dashboard.month.short.apr': 'Abr',
  'dashboard.month.short.may': 'May',
  'dashboard.month.short.jun': 'Jun',
  'dashboard.month.short.jul': 'Jul',
  'dashboard.month.short.aug': 'Ago',
  'dashboard.month.short.sep': 'Sep',
  'dashboard.month.short.oct': 'Oct',
  'dashboard.month.short.nov': 'Nov',
  'dashboard.month.short.dec': 'Dic',
  'dashboard.level.title1': 'Título 1',
  'dashboard.level.title1_1': 'Título 1.1',
  'dashboard.level.title1_1_1': 'Título 1.1.1',
  'dashboard.level.title1_1_1_1': 'Título 1.1.1.1',
  'dashboard.level.title1_1_1_1_1': 'Título 1.1.1.1.1',
  'dashboard.level.title1_1_1_1_1_1': 'Título 1.1.1.1.1.1',
  'dashboard.groupType.building': 'Edificio',
  'dashboard.groupType.client': 'Cliente',
  'dashboard.groupType.subbuilding': 'Sub Edificio',
  'dashboard.groupType.spaces': 'Ciudad',
  'dashboard.groupType.portfolio': 'Portfolio',
  'dashboard.upload.select-image': 'Seleccionar imagen',
  'dashboard.date.range.warning':
    'No se pueden generar informes con más de un año seleccionado en el rango de fechas.',
  'electric.consumption': 'Consumo eléctrico',
  'water.cons': 'Consumo de agua',
  'gas.cons': 'Consumo de gas',
  'districlima.cons': 'Consumo térmico (total)',
  'chart.temp': 'Temperatura',
  'districlima.cons.cold': 'Consumo térmico (frío)',
  'districlima.cons.hot': 'Consumo térmico (calor)',
  'chart.humid': 'Humedad',
  'chart.humid.ext': 'Humedad ext.',
  'metric.occup': 'Porcentaje de ocupación',
  'temp.ext': 'Temperatura ext.',
  'dashboard.generator': 'Generador de informes',
  'dashboard.report.headless.loading': 'Cargando los datos del informe...',
  'dashboard.report.headless.rendering':
    'Generando las gráficas del informe...',
  'dashboard.report.headless.generating': 'Creando el PDF del informe...',
  'dashboard.report.headless.done': 'Informe generado.',
  'dashboard.report.headless.timeout-error':
    'Se ha superado el tiempo máximo de espera al generar el informe. Inténtalo de nuevo o reduce el rango de fechas.',
  'dashboard.report.headless.error':
    'No se ha podido generar el PDF del informe.',
  'dashboard.widgets.image': 'Imagen',
  'dashboard.widgets.image.empty': 'Este widget no tiene imagen.',
  'dashboard.widgets.image.file': 'Imagen del widget',
  'dashboard.widgets.image.help':
    'JPEG, PNG, WebP o GIF, hasta 5 MB. Se ajusta al tamaño del widget sin deformarse.',
  'dashboard.widgets.image.invalid-type':
    'Formato no admitido. Usa JPEG, PNG, WebP o GIF.',
  'dashboard.widgets.image.too-large':
    'La imagen supera el tamaño máximo de 5 MB.',
  'dashboard.widgets.image.required': 'Selecciona una imagen.',
  /* dashboards_end_trans */
};
